import React from "react";
import { Redirect} from 'react-router-dom';
import { Routes } from '../Core/Constants';
import { UserProvider } from '../Providers/UserProvider';
import { CartProvider } from '../Providers/CartProvider';

export default class OrderView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            order: null,
            redirectToCart: false
        };
    }

    componentDidMount = () => {
		this.loadOrder();
    }

	loadOrder = function() {
		UserProvider.getOrderByInvoiceCode(this.props.invc, this.props.time, (data) => {
            this.setState({ order: data });
        });
	}

    cancelOrder = function () {

        let T = window.Texts.orders;
        if (confirm(T.cancelQuestion)){
            UserProvider.cancelOrder(this.props.invc, this.props.time)
                .done(() => {
                    this.loadOrder();
                })
                .fail(() => {
                    //could not cancel the order
                    window.alert('Cannot cancel the order');
                });
        }
	}

    addOrderToCart = () => {
        CartProvider.addOrderToCart(this.state.order, () => {
            this.setState({ redirectToCart: true });
        });
    }

    render() {
        let order = this.state.order;
        let T = window.Texts.orders;
        if (!order)
            return <div>{T.loading}</div>;

        if (this.state.redirectToCart)
            return <Redirect to={Routes.Cart} />

        return (
            <div className="order-detail-page">
                <div className="cover">
                    <div className="headline">
                        <h1>{T.orderTitle} {order.invoiceCode}</h1>
                    </div>
                    <ul className="details">
                        <li><span>{T.acceptedDay}: {order.displayCreated}</span></li>
                        <li><span>{T.state}: {T[order.displayStatus.toLowerCase() +  "Status"]}</span></li>
					
                    </ul>
                    <table className="table">
                        <tbody>
                            {order.orderedProducts.map((orderedProduct, index) => {
                                return <tr key={index}>
                                    <td className="thumb">
                                        <div className="inner">
                                            <img src={orderedProduct.product.thumb?.url} />
                                        </div>
                                    </td>
                                    <td className="name">
                                        <div className="inner">
                                            {orderedProduct.product ?
                                                <a className="no-line underline" href={orderedProduct.product.url} title={orderedProduct.productName}>
                                                    <u>{orderedProduct.productName}</u>
                                                </a> :
                                                <div className="no-line underline">
                                                    <u>{orderedProduct.productName}</u>
                                                </div>}
                                        </div>
                                    </td>
                                    <td className="count">
                                        {orderedProduct.count} x
									</td>
                                    <td className="price">
                                        <div className="inner">
                                            <span>{orderedProduct.priceTable.displayTotalPriceInclVat}</span>
                                            <small>{orderedProduct.priceTable.displayTotalPriceExclVat}
                                                bez DPH</small>
                                        </div>
                                    </td>
                                    <td className="remove" />
                                </tr>
                            })}
                        </tbody>
                    </table>
                    <div className="cart-summary">
                        <ul>
                            <li>
                                {order.canCancel ?
                                    <button className="btn btn50" disabled={!order.canCancel} onClick={() => this.cancelOrder()}>
                                        <span>{T.cancelOrder}</span>
                                    </button> : <>&nbsp;</>}
                            </li>
                            
                            <li className="price-button">

                                <div className="price">
                                    <h4>{order.priceTable.displayTotalPriceInclVat}</h4>
                                    <p>{order.priceTable.displayTotalPriceExclVat} bez DPH</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
